import { render, staticRenderFns } from "./ActionsProveedor.vue?vue&type=template&id=3f560d8a"
import script from "./ActionsProveedor.vue?vue&type=script&lang=js"
export * from "./ActionsProveedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports